const membership = {
  // قسم البطل
  heroTitle: 'اختر خطة عضويتك',
  premiumFeatures: 'مميزات متقدمة',
  prioritySupport: 'دعم ذو أولوية',
  cancelAnytime: 'إلغاء في أي وقت',

  // التبويبات
  agentMemberships: 'عضويات الوكلاء',
  premiumUserAccess: 'وصول المستخدم المتميز',

  // الشارة
  mostPopular: 'الأكثر شعبية',
  perMonth: '/شهر',
  perYear: '/سنة',

  // خطط الوكلاء
  basicAgent: 'وكيل أساسي',
  basicAgentDesc: 'مثالي للوكلاء الجدد الذين يبدؤون',
  basicFeature1: 'إدراج ما يصل إلى 10 عقارات',
  basicFeature2: 'لوحة تحليلات أساسية',
  basicFeature3: 'دعم عبر البريد الإلكتروني',
  basicFeature4: 'أدوات إدارة الممتلكات',
  basicFeature5: 'رؤية قياسية للقوائم',

  premiumAgent: 'وكيل متميز',
  premiumAgentDesc: 'الخيار الأكثر شعبية للوكلاء النشطين',
  premiumFeature1: 'إدراج ما يصل إلى 50 عقاراً',
  premiumFeature2: 'تحليلات ورؤى متقدمة',
  premiumFeature3: 'دعم ذو أولوية عبر البريد الإلكتروني والهاتف',
  premiumFeature4: 'قوائم مميزة',
  premiumFeature5: 'خيارات علامة تجارية مخصصة',
  premiumFeature6: 'أدوات توليد العملاء المحتملين',

  enterpriseAgent: 'وكيل مؤسسي',
  enterpriseAgentDesc: 'للوكالات الراسخة والفرق',
  enterpriseFeature1: 'قوائم عقارية غير محدودة',
  enterpriseFeature2: 'مجموعة تحليلات كاملة',
  enterpriseFeature3: 'دعم مخصص على مدار الساعة',
  enterpriseFeature4: 'قوائم مميزة متقدمة',
  enterpriseFeature5: 'علامة تجارية مخصصة متقدمة',
  enterpriseFeature6: 'أدوات إدارة الفريق',
  enterpriseFeature7: 'وصول إلى API',
  enterpriseFeature8: 'حلول العلامة البيضاء',

  // خطط المستخدمين
  premiumUser: 'مستخدم متميز',
  premiumUserDesc: 'احصل على وصول حصري للعقارات المتميزة والإشعارات المبكرة',
  userFeature1: 'وصول مبكر للقوائم الجديدة',
  userFeature2: 'حفظ مفضلات غير محدودة',
  userFeature3: 'مرشحات بحث متقدمة',
  userFeature4: 'إشعارات انخفاض الأسعار',
  userFeature5: 'مواعيد معاينة ذات أولوية',
  userFeature6: 'تجربة بدون إعلانات',

  // الأزرار
  subscribe: 'اشترك الآن',
  contactSales: 'تواصل مع المبيعات',

  // قسم الأسئلة الشائعة
  faqTitle: 'الأسئلة الشائعة',
  faqQuestion1: 'هل يمكنني إلغاء اشتراكي في أي وقت؟',
  faqAnswer1: 'نعم، يمكنك إلغاء اشتراكك في أي وقت من إعدادات ملفك الشخصي. سيستمر وصولك حتى نهاية فترة الفوترة الحالية.',
  faqQuestion2: 'ما هي طرق الدفع التي تقبلونها؟',
  faqAnswer2: 'نقبل جميع بطاقات الائتمان الرئيسية (فيزا، ماستركارد، أمريكان إكسبريس) ويتم معالجة المدفوعات بشكل آمن من خلال Stripe.',
  faqQuestion3: 'هل يمكنني ترقية أو تخفيض خطتي؟',
  faqAnswer3: 'نعم، يمكنك تغيير خطتك في أي وقت. عند الترقية، سيتم فرض مبلغ تناسبي. عند التخفيض، يطبق السعر الجديد في دورة الفوترة التالية.',
  faqQuestion4: 'هل هناك تجربة مجانية متاحة؟',
  faqAnswer4: 'نقدم تجربة مجانية لمدة 14 يوماً لخطط الوكيل المتميز والوكيل المؤسسي. لا حاجة لبطاقة ائتمان لبدء تجربتك.',
  faqQuestion5: 'ما الذي يحدث لقوائمي إذا ألغيت؟',
  faqAnswer5: 'ستظل قوائمك نشطة لمدة 30 يوماً بعد الإلغاء، مما يمنحك وقتاً للانتقال. بعد ذلك، سيتم أرشفتها ولكن لن يتم حذفها.',
  faqQuestion6: 'هل تقدمون خصومات للفوترة السنوية؟',
  faqAnswer6: 'نعم! وفّر 20% عندما تختار الفوترة السنوية في أي خطة. يتم تطبيق الخصم تلقائياً عند اختيار الفوترة السنوية.',

  // قسم المساعدة
  needHelpChoosing: 'تحتاج مساعدة في الاختيار؟',
  contactSalesTeam: 'تواصل مع فريق المبيعات',
  contactSalesDesc: 'فريق المبيعات لدينا هنا لمساعدتك في العثور على الخطة المثالية لاحتياجاتك.',

  // صفحة النجاح
  successTitle: 'تم تأكيد الاشتراك',
  successMessage: 'شكراً لك على الاشتراك! تم تفعيل عضويتك.',
  successDetails: 'بريد إلكتروني للتأكيد مع تفاصيل الفوترة في الطريق. يمكنك الآن الوصول إلى أدواتك المتميزة وإدارة عضويتك من ملفك الشخصي.',
  goToProfile: 'انتقل إلى الملف الشخصي',
  returnToMemberships: 'العودة إلى العضويات',
  checkoutCompleted: 'اكتملت عملية الدفع لاشتراكك.',
  sessionConfirmed: 'تم تأكيد جلسة Stripe {sessionId}.',

  // رسائل التنبيه
  signInRequired: 'يرجى تسجيل الدخول للاشتراك في خطة عضوية.',
  checkoutDisabled: 'تم تعطيل الدفع عبر Stripe في هذا الوضع التجريبي.',

  // مؤشر خطوتي الاشتراك (pages/membership/page.tsx).
  steps: {
    label: 'خطوات الاشتراك',
    choosePlan: 'اختر الباقة',
    details: 'التفاصيل والاشتراك',
  },
};

export default membership;
